import type { CrmEnrichmentJobObject } from "app/pages/sales-intelligence/modules/crm-enrichment/types/types";

export const SF_JOB_OBJECT_OPTIONS: readonly CrmEnrichmentJobObject[] = ["company", "contact", "lead"];
